import { axiosEduServer } from "../utils/configAxios";

export const crearDepartamento = (data) => {
  return axiosEduServer.post('/departamento', data).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const actualizarDepartamento = (id, data) => {
  return axiosEduServer.put(`/departamento/${id}`, data).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const eliminarDepartamento = (id) => {
  return axiosEduServer.delete(`/departamento/${id}`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getOneDepartamento = (id) => {
  return axiosEduServer.get(`/departamento/${id}`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getAllDepartamentos = () => {
  return axiosEduServer.get('/departamento').then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getAllDepartamentosByIdPais = (idPais) => {
  return axiosEduServer.get(`/departamento/idpais/${idPais}`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};